import React from "react";
import { useTranslation } from "react-i18next";

const TIER_META = {
  mini: { icon: "💎", defaultTitle: "MINI JACKPOT" },
  major: { icon: "⭐", defaultTitle: "MAJOR JACKPOT" },
  grand: { icon: "👑", defaultTitle: "GRAND JACKPOT" }
};

const COIN_COUNT = 14;
const CONFETTI_COUNT = 10;

const JackpotBannerContent = ({
  tier = "",
  amount = "",
  currency = "",
  className = "",
  onClick
}) => {
  const { t } = useTranslation();
  const meta = TIER_META[tier] || TIER_META.grand;
  const rootClassName = ["jackpot-banner", `jackpot-banner--${tier}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClassName}>
      <div className="jackpot-banner__rays" aria-hidden="true" />

      <div className="jackpot-banner__decor" aria-hidden="true">
        {Array.from({ length: COIN_COUNT }).map((_, i) => (
          <span key={`coin-${i}`} className="jackpot-banner__coin" />
        ))}
        {Array.from({ length: CONFETTI_COUNT }).map((_, i) => (
          <span key={`confetti-${i}`} className="jackpot-banner__confetti" />
        ))}
      </div>

      <div className="jackpot-banner__content">
        <div className="jackpot-banner__badge">
          <span className="jackpot-banner__icon">{meta.icon}</span>
          <span className="jackpot-banner__tier">{meta.defaultTitle}</span>
          <span className="jackpot-banner__icon">{meta.icon}</span>
        </div>

        <div className="jackpot-banner__amount-wrap">
          <span className="jackpot-banner__amount">{amount}</span>
          <span className="jackpot-banner__currency">{currency}</span>
        </div>

        <div className="jackpot-banner__sub">
          {t("The amount has been credited to your balance")}
        </div>

        <button type="button" className="jackpot-banner__cta" onClick={onClick}>
          {t("Continue")}
        </button>
      </div>
    </div>
  );
};

export default JackpotBannerContent;
